import React, { useEffect, useState } from 'react'
import { getApScores, getOverviewTexts, saveOverviewTexts } from '../../../lib/studentgparigorsummary'
import { ReportCard, ToastNotification, OverviewTextarea, UpdateButton } from './CourseReportComponents'
import style from './CourseReportStyles.module.css'

const SCORE_VALUES = [5, 4, 3, 2, 1]

export const APScoreSummary = ({ studentId, isStudent = false }) => {
	const [scoreCounts, setScoreCounts] = useState({})
	const [overview, setOverview] = useState('')
	const [showToast, setShowToast] = useState(false)

	useEffect(() => {
		loadData()
	}, [studentId])

	const loadData = async () => {
		const data = await getApScores(studentId)
		const overviewData = await getOverviewTexts(studentId)

		const scoreMap = {}
		data.forEach(({ apscore, count }) => {
			scoreMap[apscore] = count
		})

		const overviewText = overviewData.find((item) => item.type === 'capscore')?.desc || ''
		setScoreCounts(scoreMap)
		setOverview(overviewText)
	}

	const handleUpdate = async () => {
		await saveOverviewTexts(studentId, { capscore: overview })
		setShowToast(true)
		loadData()
	}

	const getTotalCount = () => SCORE_VALUES.reduce((sum, score) => sum + (scoreCounts[score] || 0), 0)

	const getAverageScore = () => {
		const total = getTotalCount()
		if (total === 0) return '-'

		const weightedSum = SCORE_VALUES.reduce((sum, score) => sum + score * (scoreCounts[score] || 0), 0)

		return (weightedSum / total).toFixed(2)
	}

	return (
		<ReportCard title="AP Scores">
			<ToastNotification show={showToast} message="Overview updated successfully" onClose={() => setShowToast(false)} />

			<div>
				<table className="table table-bordered text-center">
					<thead>
						<tr>
							<th>Score</th>
							<th>Count</th>
							<th>Overview</th>
						</tr>
					</thead>
					<tbody>
						{SCORE_VALUES.map((score, index) => (
							<tr key={score}>
								<td>{score}</td>
								<td>{scoreCounts[score] || 0}</td>
								{index === 0 && (
									<td rowSpan={SCORE_VALUES.length + 2}>
										<OverviewTextarea value={overview} onChange={setOverview} rows={10} isStudent={isStudent} className="h-100" />
									</td>
								)}
							</tr>
						))}
						<tr>
							<td>
								<strong>Total</strong>
							</td>
							<td>{getTotalCount()}</td>
						</tr>
						<tr>
							<td>
								<strong>Avg</strong>
							</td>
							<td className={style.totalCell}>{getAverageScore()}</td>
						</tr>
					</tbody>
				</table>

				<UpdateButton onClick={handleUpdate} isStudent={isStudent} />
			</div>
		</ReportCard>
	)
}
